import { useMemo } from "react";
import { useIntl } from "react-intl";

import { PeriodType } from "./xAxixTimeLabels";

export const useXAxisDynamic = (
  period: PeriodType,
  dataset: any[],
  isAllSelected: boolean = false
) => {
  const intl = useIntl();

  const monthly = useMemo(
    () => [
      intl.formatMessage({
        id: "components/pages:SalesDashBoard/lineChartEmission/XAxis/January",
        defaultMessage: "Jan",
      }),
      intl.formatMessage({
        id: "components/pages:SalesDashBoard/lineChartEmission/XAxis/February",
        defaultMessage: "Feb",
      }),
      intl.formatMessage({
        id: "components/pages:SalesDashBoard/lineChartEmission/XAxis/March",
        defaultMessage: "Mar",
      }),
      intl.formatMessage({
        id: "components/pages:SalesDashBoard/lineChartEmission/XAxis/April",
        defaultMessage: "Apr",
      }),
      intl.formatMessage({
        id: "components/pages:SalesDashBoard/lineChartEmission/XAxis/May",
        defaultMessage: "May",
      }),
      intl.formatMessage({
        id: "components/pages:SalesDashBoard/lineChartEmission/XAxis/June",
        defaultMessage: "Jun",
      }),
      intl.formatMessage({
        id: "components/pages:SalesDashBoard/lineChartEmission/XAxis/July",
        defaultMessage: "Jul",
      }),
      intl.formatMessage({
        id: "components/pages:SalesDashBoard/lineChartEmission/XAxis/August",
        defaultMessage: "Aug",
      }),
      intl.formatMessage({
        id: "components/pages:SalesDashBoard/lineChartEmission/XAxis/September",
        defaultMessage: "Sep",
      }),
      intl.formatMessage({
        id: "components/pages:SalesDashBoard/lineChartEmission/XAxis/October",
        defaultMessage: "Oct",
      }),
      intl.formatMessage({
        id: "components/pages:SalesDashBoard/lineChartEmission/XAxis/November",
        defaultMessage: "Nov",
      }),
      intl.formatMessage({
        id: "components/pages:SalesDashBoard/lineChartEmission/XAxis/December",
        defaultMessage: "Dec",
      }),
    ],
    [intl]
  );
  const quarterly = useMemo(
    () => [
      intl.formatMessage({
        id: "components/pages:SalesDashBoard/lineChartEmission/XAxis/Q1",
        defaultMessage: "Q1",
      }),
      intl.formatMessage({
        id: "components/pages:SalesDashBoard/lineChartEmission/XAxis/Q2",
        defaultMessage: "Q2",
      }),
      intl.formatMessage({
        id: "components/pages:SalesDashBoard/lineChartEmission/XAxis/Q3",
        defaultMessage: "Q3",
      }),
      intl.formatMessage({
        id: "components/pages:SalesDashBoard/lineChartEmission/XAxis/Q4",
        defaultMessage: "Q4",
      }),
    ],
    [intl]
  );

  return useMemo(() => {
    // If the chart is not all-time, we need to return all the labels based on the period
    if (!isAllSelected) {
      if (period === "MONTHLY") {
        return monthly;
      } else if (period === "QUARTERLY") {
        return quarterly;
      }
      return dataset.map((record) => {
        const { year } = record.salesDataTimePeriod;
        return `${year}`;
      });
    }
    return dataset.map((record) => {
      const { year } = record.salesDataTimePeriod;

      if (period === "MONTHLY") {
        const monthNumber = (record.salesDataTimePeriod as any).month;

        const label = monthly[monthNumber - 1];
        return `${label} ${year}`;
      }

      if (period === "QUARTERLY") {
        const quarter = (record.salesDataTimePeriod as any).quarter;
        const label = quarterly[quarter - 1];
        return `${label} ${year}`;
      }

      return `${year}`;
    });
  }, [dataset, period, monthly, isAllSelected, quarterly]);
};
